import DataTable from './DataTable';
export * from './types';

export default DataTable;
